import { render, staticRenderFns } from "./Affidavit.vue?vue&type=template&id=46079abc"
import script from "./Affidavit.vue?vue&type=script&lang=ts"
export * from "./Affidavit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports